import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { TrackerImage } from '../../../../models/tracker';
import { selectUser } from '../../../../features/user/user.selectors';
import {
  selectMarkerById,
} from '../../../../features/tracker/tracker.selectors';
import { Observable } from 'rxjs';

@Component({
    selector: 'marker-card',
    templateUrl: './marker-card.component.html',
    styleUrls: ['../card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MarkerCardComponent {

  private _markerId!: string;

  @Input({ required: true })
  set markerId(value: string) {
    this._markerId = value;
    this.marker$ = this.store.select(selectMarkerById(value));
  }
  marker$!: Observable<TrackerImage | undefined>;
  readonly currentUser$ = this.store.select(selectUser);

  constructor(private store: Store) {
  }

}
